import _construct from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.is-array";
import { BlendFunction as e, BloomEffect as t, BrightnessContrastEffect as r, ChromaticAberrationEffect as n, ColorAverageEffect as i, ColorDepthEffect as o, DepthEffect as s, DepthOfFieldEffect as c, DotScreenEffect as l, GlitchEffect as a, GlitchMode as u, GridEffect as d, HueSaturationEffect as m, NoiseEffect as p, OutlineEffect as f, PixelationEffect as g, ScanlineEffect as b, SepiaEffect as h, EffectComposer as w, RenderPass as E, NormalPass as v, EffectPass as x, SSAOEffect as y, SMAAImageLoader as j, SMAAEffect as P, TextureEffect as S, VignetteEffect as T } from "postprocessing";
import D from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import L, { forwardRef as O, useMemo as A, useLayoutEffect as F, createContext as R, useEffect as z, useRef as C, useContext as M } from "react";
import { Vector2 as I, Vector3 as N, HalfFloatType as _, TextureLoader as B, sRGBEncoding as Y, RepeatWrapping as k } from "three";
import G from "@babel/runtime/helpers/esm/extends";
import { useThree as J, useFrame as U, useLoader as V } from "react-three-fiber";

var W = function W(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.NORMAL;
  return O(function (e, n) {
    var i = e.blendFunction,
        o = e.opacity,
        s = D(e, ["blendFunction", "opacity"]);
    var c = A(function () {
      return new t(s);
    }, [JSON.stringify(s)]);
    return F(function () {
      c.blendMode.blendFunction = i || r, void 0 !== o && (c.blendMode.opacity.value = o);
    }, [i, o]), L.createElement("primitive", {
      ref: n,
      object: c,
      dispose: null
    });
  });
},
    q = function q(e, t) {
  var r = e[t];
  return A(function () {
    if (r instanceof I) return new I().set(r.x, r.y);

    if (Array.isArray(r)) {
      var _r = _slicedToArray(r, 2),
          _e = _r[0],
          _t = _r[1];

      return new I().set(_e, _t);
    }
  }, [e[t]]);
},
    H = W(t, e.SCREEN),
    K = W(r),
    Q = O(function (e, t) {
  var r = q(e, "offset"),
      i = A(function () {
    return new n(G({}, e, {
      offset: r
    }));
  }, [e]);
  return L.createElement("primitive", {
    ref: t,
    object: i,
    dispose: null
  });
}),
    X = O(function (_ref, r) {
  var _ref$blendFunction = _ref.blendFunction,
      t = _ref$blendFunction === void 0 ? e.NORMAL : _ref$blendFunction;
  var n = A(function () {
    return new i(t);
  }, [t]);
  return L.createElement("primitive", {
    ref: r,
    object: n,
    dispose: null
  });
}),
    Z = W(o),
    $ = W(s),
    ee = O(function (e, t) {
  var r = e.target,
      n = e.depthTexture,
      i = D(e, ["target", "depthTexture"]);

  var _J = J(),
      o = _J.camera,
      s = A(function () {
    return new c(o, i);
  }, [i]);

  return F(function () {
    if (r) {
      var _e2 = r instanceof N ? new N().set(r.x, r.y, r.z) : new N().set(r[0], r[1], r[2]);

      s.target = _e2;
    }

    n && s.setDepthTexture(n.texture, n.packing);
  }, [r, n]), L.createElement("primitive", {
    ref: t,
    object: s,
    dispose: null
  });
}),
    te = W(l),
    re = O(function (e, t) {
  var r = e.active,
      n = D(e, ["active"]);
  var i = q(n, "delay"),
      o = q(n, "duration"),
      s = q(n, "strength"),
      c = A(function () {
    return new a(G({}, n, {
      delay: i,
      duration: o,
      strength: s
    }));
  }, [n]);
  return F(function () {
    c.mode = r ? n.mode || u.SPORADIC : u.DISABLED;
  }, [r]), L.createElement("primitive", {
    ref: t,
    object: c,
    dispose: null
  });
}),
    ne = O(function (e, t) {
  var r = e.size,
      n = D(e, ["size"]);
  var i = A(function () {
    return new d(n);
  }, [n]);
  return F(function () {
    r && i.setSize(r.width, r.height);
  }, [r]), L.createElement("primitive", {
    ref: t,
    object: i,
    dispose: null
  });
}),
    ie = W(m),
    oe = W(p, e.COLOR_DODGE),
    se = O(function (e, t) {
  var _J2 = J(),
      r = _J2.scene,
      n = _J2.camera,
      i = A(function () {
    return new f(r, n, G({
      xRay: !0,
      edgeStrength: 2.5,
      pulseSpeed: 0,
      visibleEdgeColor: 16777215,
      hiddenEdgeColor: 2230538
    }, e));
  }, [e]);

  return L.createElement("primitive", {
    ref: t,
    object: i,
    dispose: null
  });
}),
    ce = O(function (_ref2, t) {
  var _ref2$granularity = _ref2.granularity,
      e = _ref2$granularity === void 0 ? 5 : _ref2$granularity;
  var r = A(function () {
    return new g(e);
  }, [e]);
  return L.createElement("primitive", {
    ref: t,
    object: r,
    dispose: null
  });
}),
    le = W(b, e.OVERLAY),
    ae = W(h),
    ue = R(null),
    de = L.memo(function (e) {
  var t = e.children,
      _e$renderPriority = e.renderPriority,
      r = _e$renderPriority === void 0 ? 1 : _e$renderPriority,
      _e$multisampling = e.multisampling,
      n = _e$multisampling === void 0 ? 8 : _e$multisampling,
      i = D(e, ["children", "renderPriority", "multisampling"]);

  var _J3 = J(),
      o = _J3.gl,
      s = _J3.scene,
      c = _J3.camera,
      l = _J3.size,
      _A = A(function () {
    var e = new w(o, G({
      multisampling: n,
      frameBufferType: _
    }, i));
    e.addPass(new E(s, c));
    var t = new v(s, c);
    return e.addPass(t), [e, t];
  }, [c, o, s]),
      _A2 = _slicedToArray(_A, 2),
      a = _A2[0],
      u = _A2[1];

  z(function () {
    a.setSize(l.width, l.height);
  }, [a, l]), U(function (e, t) {
    return a.render(t);
  }, r);
  var d = C();
  z(function () {
    if (d.current) {
      var _e3 = _construct(x, [c].concat(_toConsumableArray(d.current.__objects)));

      return a.addPass(_e3), _e3.renderToScreen = !0, function () {
        return a.removePass(_e3);
      };
    }
  }, [a, c, t]);
  var m = A(function () {
    return {
      composer: a,
      normalPass: u
    };
  }, [a, u]);
  return L.createElement(ue.Provider, {
    value: m
  }, L.createElement("group", {
    ref: d
  }, t));
}),
    me = O(function (t, r) {
  var _J4 = J(),
      n = _J4.camera,
      _M = M(ue),
      i = _M.normalPass,
      o = A(function () {
    return new y(n, i.renderTarget.texture, G({
      blendFunction: e.MULTIPLY,
      samples: 30,
      rings: 4,
      distanceThreshold: 1,
      distanceFalloff: 0,
      rangeThreshold: .5,
      rangeFalloff: .1,
      luminanceInfluence: .9,
      radius: 20,
      scale: .5,
      bias: .5
    }, t));
  }, [t]);

  return L.createElement("primitive", {
    ref: r,
    object: o,
    dispose: null
  });
}),
    pe = O(function (_ref3, t) {
  var _ref3$edgeDetection = _ref3.edgeDetection,
      e = _ref3$edgeDetection === void 0 ? .1 : _ref3$edgeDetection;
  var r = V(j, ""),
      n = A(function () {
    return _construct(P, _toConsumableArray(r));
  }, [r]);
  return F(function () {
    n.colorEdgesMaterial.setEdgeDetectionThreshold(e);
  }, [e]), L.createElement("primitive", {
    ref: t,
    object: n,
    dispose: null
  });
}),
    fe = O(function (e, t) {
  var r = e.textureSrc,
      n = e.texture,
      i = D(e, ["textureSrc", "texture"]);
  var o = V(B, r);
  F(function () {
    o.encoding = Y, o.wrapS = o.wrapT = k;
  }, [o]);
  var s = A(function () {
    return new S(G({}, i, {
      texture: o || n
    }));
  }, [i]);
  return L.createElement("primitive", {
    ref: t,
    object: s,
    dispose: null
  });
}),
    ge = W(T);

export { H as Bloom, K as BrightnessContrast, Q as ChromaticAberration, X as ColorAverage, Z as ColorDepth, $ as Depth, ee as DepthOfField, te as DotScreen, de as EffectComposer, ue as EffectComposerContext, re as Glitch, ne as Grid, ie as HueSaturation, oe as Noise, se as Outline, ce as Pixelation, pe as SMAA, me as SSAO, le as Scanline, ae as Sepia, fe as Texture, ge as Vignette };